import { render } from "./TheMetadataSampleLayout.vue?vue&type=template&id=6abe525e&scoped=true"
import script from "./TheMetadataSampleLayout.vue?vue&type=script&lang=js"
export * from "./TheMetadataSampleLayout.vue?vue&type=script&lang=js"

import "./TheMetadataSampleLayout.vue?vue&type=style&index=0&id=6abe525e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abe525e"]])

export default __exports__